import _sfc_main from "./InvitePanel.vue2.mjs";
/* empty css                  */
import normalizeComponent from "../../_virtual/_plugin-vue2_normalizer.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", { class: ["invite-member", _setup.isMobile ? "h5" : ""] }, [_vm._l(_setup.scheduleInviteList, function(item, index) {
    return [item.isVisible ? _c("div", { key: index, staticClass: "invite-member-container" }, [_c("span", { staticClass: "invite-member-title" }, [_vm._v(_vm._s(_setup.t(item.title)))]), _c("span", { staticClass: "invite-member-content", attrs: { "title": item.content } }, [_vm._v(" " + _vm._s(item.content) + " ")]), item.isShowCopyIcon ? _c(_setup.SvgIcon, { staticClass: "copy", attrs: { "icon": _setup.copyIcon }, on: { "click": function($event) {
      return _setup.onCopy(item.content);
    } } }) : _vm._e()], 1) : _vm._e()];
  })], 2);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "50de092b"
);
const InvitePanel = __component__.exports;
export {
  InvitePanel as default
};
